/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M467.118 385.208c-9.805 0-19.558-4.147-26.393-12.211l-184.808-218.01-185.013 218.01c-12.314 14.54-34.176 16.358-48.692 3.993-14.566-12.339-16.358-34.15-3.993-48.716l211.38-249.088A34.55 34.55 0 01255.943 67c10.138 0 19.79 4.48 26.368 12.211L493.46 328.3c12.34 14.567 10.523 36.378-4.018 48.717a34.396 34.396 0 01-22.324 8.192"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconBracketUp = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconBracketUp.defaultProps = {
  theme,
};
IconBracketUp.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconBracketUp.displayName = 'IconBracketUp';
export { IconBracketUp };
